import actions from './constants';

export const showSaveRole = (code, category) => ({
  type: actions.SHOW_SAVE_ROLE,
  code,
  category,
});

export const hideSaveRole = () => ({
  type: actions.HIDE_SAVE_ROLE,
});

export const showConfirmPermissions = (code, category) => ({
  type: actions.SHOW_CONFIRM_PERMISSIONS,
  code,
  category,
});

export const hideConfirmPermissions = () => ({
  type: actions.HIDE_CONFIRM_PERMISSIONS,
});

export const updateRoleProperties = (code, category, properties) => ({
  type: actions.UPDATE_ROLE_PROPERTIES,
  code,
  category,
  properties,
});

export const toggleRolePermission = (category, code, roleCategory, roleAction) => ({
  type: actions.TOGGLE_ROLE_PERMISSION,
  code,
  category,
  roleCategory,
  roleAction,
});

export const updateRolePermissions = (category, code, permissionCategories, status) => ({
  type: actions.UPDATE_ROLE_PERMISSIONS,
  category,
  code,
  permissionCategories,
  status,
});

export const updateActiveRoleProperties = (properties) => ({
  type: actions.UPDATE_ACTIVE_ROLE_PROPERTIES,
  properties,
});

export const fetchRoles = (category, page, pageSize, append) => ({
  type: actions.FETCH_ROLES,
  category,
  page,
  pageSize,
  append,
});

export const refreshRoles = (category, page) => ({
  type: actions.REFRESH_ROLES,
  category,
  page,
});

export const toggleRoleSelected = (code, category) => ({
  type: actions.TOGGLE_ROLE_SELECTED,
  code,
  category,
});

export const toggleRolesSelected = (category, selected) => ({
  type: actions.TOGGLE_ROLES_SELECTED,
  category,
  selected,
});

export const updateRolesFilter = (category, value) => ({
  type: actions.UPDATE_ROLES_FILTER,
  category,
  value,
});

export const updateRolesFlags = (category, userFlag, tokenFlag, assignable) => ({
  type: actions.UPDATE_ROLES_FLAGS,
  category,
  userFlag,
  tokenFlag,
  assignable,
});

export const updateRoleFilter = (code, category, value) => ({
  type: actions.UPDATE_ROLE_FILTER,
  code,
  category,
  value,
});

export const updatePermissionsPanels = (code, category, index, panel) => ({
  type: actions.UPDATE_PERMISSIONS_PANELS,
  code,
  category,
  panel,
  index,
});

export const showRoles = (category, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: actions.SHOW_ROLES,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showRolesError = (category, error) => ({
  type: actions.SHOW_ROLES_ERROR,
  category,
  error,
});

export const closeRoles = ({ category }) => ({
  type: actions.CLOSE_ROLES,
  category,
});

export const fetchRole = (category, code) => ({
  type: actions.FETCH_ROLE,
  category,
  code,
});

export const showRole = (category, code, result) => ({
  type: actions.SHOW_ROLE,
  category,
  code,
  result,
});

export const showRoleError = (category, code, error) => ({
  type: actions.SHOW_ROLE_ERROR,
  category,
  code,
  error,
});

export const closeRole = ({ category, code }) => ({
  type: actions.CLOSE_ROLE,
  category,
  code,
});

export const createRole = (token) => ({
  type: actions.CREATE_ROLE,
  token,
});

export const newRole = (result) => ({
  type: actions.NEW_ROLE, result,
});

export const newRoleError = (error) => ({
  type: actions.NEW_ROLE_ERROR,
  error,
});

export const updateRole = (category, code) => ({
  type: actions.UPDATE_ROLE,
  category,
  code,
});

export const editRole = (category, code) => ({
  type: actions.EDIT_ROLE,
  category,
  code,
});

export const editRoleSuccess = (category, code, result) => ({
  type: actions.EDIT_ROLE_SUCCESS, category, code, result,
});

export const editRoleError = (category, code, error) => ({
  type: actions.EDIT_ROLE_ERROR,
  category,
  code,
  error,
});

export const editRoleCancel = (category, code) => ({
  type: actions.EDIT_ROLE_CANCEL,
  category,
  code,
});

export const updateUsersRole = () => ({
  type: actions.UPDATE_USERS_ROLE,
});

export const showRoleReassign = (users) => ({
  type: actions.SHOW_ROLE_REASSIGN,
  users,
});

export const updateRoleSuccess = (role, items) => ({
  type: actions.UPDATE_USERS_ROLE_SUCCESS, role, items,
});

export const updateRoleError = (errors) => ({
  type: actions.UPDATE_USERS_ROLE_ERROR,
  errors,
});

export const hideRoleReassign = () => ({
  type: actions.HIDE_USERS_ROLE_REASSIGN,
});

export const showDefaultRole = () => ({
  type: actions.SHOW_DEFAULT_ROLE,
});

export const hideDefaultRole = () => ({
  type: actions.HIDE_DEFAULT_ROLE,
});

export const fetchDefaultRole = () => ({
  type: actions.FETCH_DEFAULT_ROLE,
});

export const applyDefaultRoleCode = (code) => ({
  type: actions.APPLY_DEFAULT_ROLE_CODE,
  code,
});

export const toggleRolesPresentation = (category, display) => ({
  type: actions.TOGGLE_ROLES_PRESENTATION,
  category,
  display,
});
